import { nativeRedirect } from './native_redirect'
import { nativeRoutes } from './native_redirect/routes'
import { Dialog } from 'vant'

export const login = url => {
  const data = url
    ? {
        sucurl: encodeURIComponent(url)
      }
    : {}
  nativeRedirect(nativeRoutes.login, data)
}

export const loginConfirm = url => {
  Dialog.confirm({
    message: '您尚未登录',
    cancelButtonText: '稍后再说',
    confirmButtonText: '确定'
  }).then(() => {
    const data = url
      ? {
          sucurl: encodeURIComponent(url)
        }
      : {}
    nativeRedirect(nativeRoutes.login, data)
  })
}
